// Function loadshopListingBlock loads the shopListingBlock class by dynamically importing the js on demand if needed

export function loadShopListingBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-shop-listing-block-chunk" */ '../widgets/shopListingBlock').then(wg => {

		const { ShopListingBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ShopListingBlock"]');

		if(!$wg) {
			// console.info('ShopListingBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ShopListingBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ShopListingBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ShopListingBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ShopListingBlock widget');

}
